import React, {
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import ScrollContext from 'containers/ScrollContext';
import ViewportContext from 'containers/ViewportContext';
import { bp } from 'theme';
import { isDefined } from 'utils/functional';

type Props = {
  children: (arg0: {
    isAboveViewport: boolean;
    isFullyAboveViewport: boolean;
    isAboveOffset: boolean;
    isInViewport: boolean;
    isFullyInViewport: boolean;
  }) => ReactNode;
  offset?: Array<number>;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ScrollWatcherContainer = ({ children, offset }: Props) => {
  const [, scrollY] = useContext(ScrollContext);
  const [viewportWidth, viewportHeight] = useContext(ViewportContext);
  const [isAboveViewport, setIsAboveViewport] = useState(false);
  const [isFullyAboveViewport, setIsFullyAboveViewport] = useState(false);
  const [isAboveOffset, setIsAboveOffset] = useState(false);
  const [isInViewport, setIsInViewport] = useState(false);
  const [isFullyInViewport, setIsFullyInViewport] = useState(false);
  const [height, setHeight] = useState();
  const [threshold, setThreshold] = useState();
  const [bottomThreshold, setBottomThreshold] = useState();
  const watchedElement = useRef(null);
  const currentBreakpoint = useMemo(() => {
    if (offset) {
      const breakpoint = bp.reduce(
        (acc, point, index) =>
          viewportWidth >= point && offset[index] ? index : acc,
        0
      );
      return offset[breakpoint];
    }

    return 0;
  }, [offset, viewportWidth]);
  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    const thresholdValue: number = isDefined(threshold)
      ? threshold
      : watchedElement && watchedElement.current
      ? watchedElement.current.getBoundingClientRect().top
      : 0;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    const bottomThresholdValue: number = isDefined(bottomThreshold)
      ? bottomThreshold
      : watchedElement && watchedElement.current
      ? watchedElement.current.getBoundingClientRect().bottom
      : 0;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    const heightValue: number = isDefined(height)
      ? height
      : watchedElement && watchedElement.current
      ? watchedElement.current.getBoundingClientRect().height
      : 0;
    const newIsAboveViewport = scrollY > thresholdValue;
    const newIsFullyAboveViewport =
      scrollY > thresholdValue + heightValue - currentBreakpoint;
    const newIsAboveOffset = offset
      ? scrollY > thresholdValue - currentBreakpoint
      : false;
    const newIsInViewport =
      window.innerHeight + scrollY >
      heightValue + thresholdValue - currentBreakpoint;
    const newIsFullyInViewport =
      thresholdValue >= scrollY && bottomThresholdValue <= window.innerHeight;
    setIsFullyAboveViewport(newIsFullyAboveViewport);
    setIsAboveViewport(newIsAboveViewport);
    setIsAboveOffset(newIsAboveOffset);
    setIsInViewport(newIsInViewport);
    setIsFullyInViewport(newIsFullyInViewport);
  }, [bottomThreshold, currentBreakpoint, height, offset, scrollY, threshold]);
  useEffect(() => {
    if (watchedElement && watchedElement.current) {
      const {
        height: newHeight,
        bottom,
        top,
      } = watchedElement.current.getBoundingClientRect();
      setHeight(newHeight);
      setThreshold(top + scrollY);
      setBottomThreshold(bottom + scrollY);
      const count = 0;

      const timer = () => {
        window.setTimeout(() => {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          if ((isDefined(height) && height > 0) || count >= 10) {
            return;
          }

          timer();
        }, 50);
      };

      timer();
    }
  }, [height, scrollY, viewportHeight, viewportWidth]);
  return (
    <div ref={watchedElement}>
      {children({
        isAboveViewport,
        isFullyAboveViewport,
        isAboveOffset,
        isInViewport,
        isFullyInViewport,
      })}
    </div>
  );
};

export default ScrollWatcherContainer;
